<template>

<b-modal ref="bModal" @ok="$emit('save', project)" title="Editar Proyecto" size="lg" header-bg-variant="primary"
         header-text-variant="light" ok-title="Guardar" cancel-title="Cancelar">
  <project-form v-model="project" :client="project.clientDTO" :managers="project.managers"/>
</b-modal>

</template>

<script>

import ProjectForm from './ProjectForm'
import {cloneDeep} from 'lodash'

export default {
  name: 'EditProjectModal',
  components: {ProjectForm},
  data() {
    return {
      project: {}
    }
  },
  methods: {
    show(project) {
      this.project = cloneDeep(project)
      this.$refs.bModal.show()
    }
  }
}

</script>



// WEBPACK FOOTER //
// src/components/project/EditProjectModal.vue